export var AppTabs = {
    PRODUCTS: {
        id: "products",
        label: "Products",
        path: "/",
    },
    FEEDBACK: {
        id: "feedback",
        label: "Feedback",
        path: "/feedback",
    },
    ABOUT: {
        id: "about",
        label: "About",
        path: "/about",
    },
};
